export const createDocumentPrompts = (
  documentType: string,
  standardDescription: string,
  enhancedDescription: string,
  premiumDescription: string
) => ({
  standard: `You are a UK legal expert specializing in ${documentType}. Generate a comprehensive STANDARD VERSION ${documentType} with proper formatting.

CRITICAL FORMATTING REQUIREMENTS:
- Use clear hierarchical structure with numbered sections (1., 2., 3., etc.)
- Use subsections where appropriate (1.1, 1.2, 1.3, etc.)
- Add blank lines between major sections for readability
- Use ALL CAPS for major section headings
- Use Title Case for subsection headings
- Include a clear Table of Contents at the beginning
- Use bullet points for lists within clauses
- Ensure consistent indentation and spacing
- Add clear "SIGNATURES" section at the end with signature blocks

${standardDescription}`,

  enhanced: `You are a UK legal expert specializing in ${documentType}. Generate a comprehensive ENHANCED VERSION ${documentType} with proper formatting.

CRITICAL FORMATTING REQUIREMENTS:
- Use clear hierarchical structure with numbered sections (1., 2., 3., etc.)
- Use detailed subsections (1.1, 1.2, 1.3, etc.) and sub-subsections (1.1.1, 1.1.2, etc.)
- Add blank lines between major sections for readability
- Use ALL CAPS for major section headings with separator lines (====)
- Use Title Case for subsection headings
- Include a comprehensive Table of Contents at the beginning
- Use bullet points and numbered lists for clarity
- Add "SCHEDULE" sections for detailed appendices
- Ensure consistent indentation and spacing throughout
- Include clear signature blocks with witness sections
- Add professional header with document title and version

${enhancedDescription}`,

  premium: `You are a UK legal expert specializing in ${documentType}. Generate a comprehensive PREMIUM VERSION ${documentType} with professional formatting.

CRITICAL FORMATTING REQUIREMENTS:
- Use professional hierarchical structure with numbered sections (1., 2., 3., etc.)
- Use comprehensive subsections (1.1, 1.2) and detailed sub-subsections (1.1.1, 1.1.2, 1.1.3)
- Include article-level numbering for complex clauses (1.1.1(a), 1.1.1(b), 1.1.1(c))
- Add blank lines and separator lines between major sections
- Use BOLD ALL CAPS for major section headings with double separator lines
- Use Bold Title Case for subsection headings
- Include comprehensive Table of Contents with section and page references
- Add detailed SCHEDULES and APPENDICES sections
- Use professional formatting with consistent indentation (4 spaces per level)
- Include bullet points, numbered lists, and lettered sub-points
- Add execution clause with formal signature blocks for all parties and witnesses
- Include document control footer with version, date, and page numbers
- Add cross-references between related sections

${premiumDescription}`
});
